import InsuranceTypeForm from '@/modules/health/rater/views/pages/InsuranceTypeForm.vue'
import CopayForm from '@/modules/health/rater/views/pages/CopayForm.vue'
import CoveragesForm from '@/modules/health/rater/views/pages/CoveragesForm.vue'
import AbroadOptionsForm from '@/modules/health/rater/views/pages/AbroadOptionsForm.vue'
import StartDateForm from '@/modules/common/rater/views/forms/StartDateForm.vue'
import ForWhomForm from '@/modules/common/rater/views/forms/ForWhomForm.vue'
import MoreInfoForm from '@/modules/common/rater/views/forms/MoreInfoForm.vue'
import type FormPage from '@/modules/common/common/models/APP/FormPage'

export default {
  ForWhom: {
    form: ForWhomForm,
    next: ['InsuranceTypeForm']
  },
  InsuranceTypeForm: {
    form: InsuranceTypeForm,
    next: ['CopayForm', 'StartDateForm', 'AbroadOptionsForm']
  },
  StartDateForm: {
    form: StartDateForm,
    next: ['MoreInfoForm']
  },
  CopayForm: {
    form: CopayForm,
    next: ['StartDateForm']
  },
  AbroadOptionsForm: {
    form: AbroadOptionsForm,
    next: ['StartDateForm']
  },
  MoreInfoForm: {
    form: MoreInfoForm,
    next: ['CoveragesForm'],
    extra: { useTooOldGreaterOrEqual: true }
  },
  CoveragesForm: {
    form: CoveragesForm,
    next: []
  }
} as Record<string, FormPage>
